import styled from 'styled-components';
import { StyledModal } from '../../../common/shared/modal.styled';
import Table from '../../../common/table/TableFunctional';

export const StyledCreditCardChoiceModal = styled(StyledModal)`
    .modal-dialog {
        max-width: 70%;
    }
    .modal-dialog {
        .modal-body {
            padding: 20px;
            .info-text {
                text-align: center;
                margin-bottom: 30px;
            }
        }
    }

    .check {
      display: flex;
      align-items: center;
      label {
        margin: 0 0 0 10px;
      }
    }
    .checkbox {
      align-items: center;
      justify-content: center;
      align-self: stretch;
      width: 100%;
      img {
        width: 18px;
      }
    }
`

export const StyledTable = styled(Table)`
    margin-bottom: 20px;
    #table {
      width: auto !important;
      margin-bottom: 0 !important;
    }
`